import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=28cd6a29&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=28cd6a29&prod&lang=scss&scoped=true&"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=28cd6a29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd6a29",
  null
  
)

export default component.exports